import { Language } from './core/Storage.ts';

export interface LevelI18n {
  name: string;
  bannerSub: string;
}

export interface I18nDictionary {
  docTitle: string;
  badge18: string;
  gameTitle: string;
  tagline: string;
  startBtn: string;
  rulesBtn: string;
  rulesModalTitle: string;
  rulesSubtitle: string;
  ruleGirl: string;
  rulePenis: string;
  ruleGrenade: string;
  ruleMonkey: string;
  ruleDog: string;
  ruleGirlName: string;
  ruleGirlDesc: string;
  rulePenisName: string;
  rulePenisDesc: string;
  ruleGrenadeName: string;
  ruleGrenadeDesc: string;
  ruleMonkeyName: string;
  ruleMonkeyDesc: string;
  ruleDogName: string;
  ruleDogDesc: string;
  controlsTitle: string;
  controlsMobile: string;
  controlsPC: string;
  modalStartBtn: string;
  menuHighscoreLabel: string;
  scoreBtnTitle: string;
  scoreModalTitle: string;
  scoreModalOkBtn: string;
  hudTopLabel: string;
  pauseBtnTitle: string;
  muteBtnTitle: string;
  pauseTitle: string;
  resumeBtn: string;
  pauseRulesBtn: string;
  exitBtn: string;
  gameOverTitle: string;
  newRecord: string;
  statScore: string;
  statLevel: string;
  statBest: string;
  restartBtn: string;
  modelsTitle: string;
  modelsGallery: string;
  girlRandom: string;
  girlDiveWhite: string;
  girlDiveRed: string;
  girlPoseBack: string;
  girlPoseKneel: string;
  girlPinupRed: string;
  girlPinupPink: string;
  levels: Record<number, LevelI18n>;
  floating: {
    boom: string;
    turbo: string;
    turboBadge: string;
  };
  analyticsLabel: string;
  analyticsDesc: string;
  analyticsOn: string;
  analyticsOff: string;
}

export const TRANSLATIONS: Record<Language, I18nDictionary> = {
  ru: {
    docTitle: 'VIP-Поднос 18+ — Взрослая Аркада',
    badge18: '18+',
    gameTitle: 'VIP-ПОДНОС',
    tagline: 'ЛОВИ КАЙФ!',
    startBtn: 'ИГРАТЬ!',
    rulesBtn: 'ПРАВИЛА ИГРЫ',
    rulesModalTitle: '📖 ПРАВИЛА ИГРЫ',
    rulesSubtitle: 'Управляй подносом официанта и лови бонусы, уворачиваясь от ловушек!',
    ruleGirl: 'Красотка: <strong>+10 очков (Серия = COMBO x2, x3!)</strong>',
    rulePenis: 'Член: <strong style="color: #00f0ff;">-1 жизнь (Ловушка!)</strong>',
    ruleGrenade: 'Граната: <strong style="color: #ff3300;">-1 жизнь + Бабах!</strong>',
    ruleMonkey: 'Обезьянка: <strong>+5 очков + ⚡ Турбо 5с</strong>',
    ruleDog: 'Собака: <strong>+5 очков (Гав!)</strong>',
    ruleGirlName: 'Красотка',
    ruleGirlDesc: '<strong>+10 очков</strong>. Лови подряд для серии <strong>COMBO x2, x3, x4!</strong>',
    rulePenisName: 'Член (Ловушка)',
    rulePenisDesc: '<strong style="color: #00f0ff;">-1 жизнь</strong>. Коварная подстава, уворачивайся!',
    ruleGrenadeName: 'Граната',
    ruleGrenadeDesc: '<strong style="color: #ff3300;">-1 жизнь</strong> + Бабах и тряска экрана!',
    ruleMonkeyName: 'Обезьянка',
    ruleMonkeyDesc: '<strong>+5 очков</strong> + ⚡ <strong>Турбо 5с</strong> (быстрое движение)!',
    ruleDogName: 'Собака',
    ruleDogDesc: '<strong>+5 очков</strong> (Гав-гав!). Преданный друг вечеринки.',
    controlsTitle: '🕹️ Управление:',
    controlsMobile: '📱 <strong>Смартфон:</strong> веди пальцем влево/вправо по экрану',
    controlsPC: '⌨️ <strong>ПК:</strong> клавиши <strong>A / D</strong>, стрелки <strong>← / →</strong>, пауза <strong>Esc</strong>',
    modalStartBtn: 'ВСЁ ПОНЯТНО, В БОЙ! 🎮',
    menuHighscoreLabel: 'Лучший счёт:',
    scoreBtnTitle: 'Лучший рекорд',
    scoreModalTitle: '🏆 ЛУЧШИЙ РЕКОРД',
    scoreModalOkBtn: 'КРУТО! 🔥',
    hudTopLabel: 'ТОП:',
    pauseBtnTitle: 'Пауза (Esc / P / Space)',
    muteBtnTitle: 'Звук (M)',
    pauseTitle: 'ПАУЗА',
    resumeBtn: 'ПРОДОЛЖИТЬ',
    pauseRulesBtn: 'ПРАВИЛА',
    exitBtn: 'В МЕНЮ',
    gameOverTitle: 'ТУСОВКА ОКОНЧЕНА!',
    newRecord: '🔥 НОВЫЙ РЕКОРД! 🔥',
    statScore: 'Набрано очков:',
    statLevel: 'Достигнутый уровень:',
    statBest: 'Лучший рекорд:',
    restartBtn: 'ТУСИТЬ ЗАНОВО',
    modelsTitle: 'Девушки на подносе:',
    modelsGallery: 'Галерея',
    girlRandom: '🎲 Случайный выбор',
    girlDiveWhite: '🤿 Брюнетка (нырок)',
    girlDiveRed: '💋 Рыжая (нырок)',
    girlPoseBack: '🍑 Вид сзади',
    girlPoseKneel: '🧎 На коленях',
    girlPinupRed: '🔥 Classic Red',
    girlPinupPink: '💖 Neon Pink',
    levels: {
      1: {
        name: 'Неоновый Стрип-Клуб',
        bannerSub: ''
      },
      2: {
        name: 'Пентхаус: Мальчишник',
        bannerSub: 'СКОРОСТЬ x1.5! ДЕРЖИСЬ!'
      },
      3: {
        name: 'Райский Пляж Ибицы',
        bannerSub: 'ХАРДКОР! УВОРАЧИВАЙСЯ!'
      }
    },
    floating: {
      boom: '💥 БАБАХ!',
      turbo: '⚡ ТУРБО +5',
      turboBadge: '⚡ ТУРБО'
    },
    analyticsLabel: '📊 Анонимная аналитика',
    analyticsDesc: 'Помогает улучшать игру (без личных данных)',
    analyticsOn: 'ВКЛ',
    analyticsOff: 'ВЫКЛ'
  },
  en: {
    docTitle: 'VIP Tray 18+ — Adult Arcade',
    badge18: '18+',
    gameTitle: 'VIP TRAY',
    tagline: 'CATCH THE VIBE!',
    startBtn: 'PLAY!',
    rulesBtn: 'HOW TO PLAY',
    rulesModalTitle: '📖 HOW TO PLAY',
    rulesSubtitle: 'Catch hot party bonuses on the waiter\'s tray and dodge the traps!',
    ruleGirl: 'Hot Babe: <strong>+10 pts (Streak = COMBO x2, x3!)</strong>',
    rulePenis: 'Eggplant: <strong style="color: #00f0ff;">-1 life (Trap!)</strong>',
    ruleGrenade: 'Grenade: <strong style="color: #ff3300;">-1 life + BOOM!</strong>',
    ruleMonkey: 'Monkey: <strong>+5 pts + ⚡ Turbo 5s</strong>',
    ruleDog: 'Dog: <strong>+5 pts (Woof!)</strong>',
    ruleGirlName: 'Hot Babe',
    ruleGirlDesc: '<strong>+10 pts</strong>. Catch consecutively for <strong>COMBO x2, x3, x4!</strong>',
    rulePenisName: 'Eggplant (Trap)',
    rulePenisDesc: '<strong style="color: #00f0ff;">-1 life</strong>. Sneaky trap, dodge it!',
    ruleGrenadeName: 'Grenade',
    ruleGrenadeDesc: '<strong style="color: #ff3300;">-1 life</strong> + BOOM and screen shake!',
    ruleMonkeyName: 'Monkey',
    ruleMonkeyDesc: '<strong>+5 pts</strong> + ⚡ <strong>Turbo 5s</strong> (tray speed boost)!',
    ruleDogName: 'Dog',
    ruleDogDesc: '<strong>+5 pts</strong> (Woof!). Loyal party companion.',
    controlsTitle: '🕹️ Controls:',
    controlsMobile: '📱 <strong>Mobile:</strong> drag finger left/right on screen',
    controlsPC: '⌨️ <strong>PC:</strong> keys <strong>A / D</strong>, arrows <strong>← / →</strong>, pause <strong>Esc</strong>',
    modalStartBtn: 'GOT IT, LET\'S PLAY! 🎮',
    menuHighscoreLabel: 'Best Score:',
    scoreBtnTitle: 'Best Score',
    scoreModalTitle: '🏆 BEST SCORE',
    scoreModalOkBtn: 'AWESOME! 🔥',
    hudTopLabel: 'TOP:',
    pauseBtnTitle: 'Pause (Esc / P / Space)',
    muteBtnTitle: 'Sound (M)',
    pauseTitle: 'PAUSED',
    resumeBtn: 'RESUME',
    pauseRulesBtn: 'RULES',
    exitBtn: 'MAIN MENU',
    gameOverTitle: 'PARTY OVER!',
    newRecord: '🔥 NEW RECORD! 🔥',
    statScore: 'Score:',
    statLevel: 'Level Reached:',
    statBest: 'Best Score:',
    restartBtn: 'PLAY AGAIN',
    modelsTitle: 'Babes on Tray:',
    modelsGallery: 'Gallery',
    girlRandom: '🎲 Random Girls',
    girlDiveWhite: '🤿 Diving Brunette',
    girlDiveRed: '💋 Diving Redhead',
    girlPoseBack: '🍑 Back View',
    girlPoseKneel: '🧎 Kneeling Babe',
    girlPinupRed: '🔥 Classic Red',
    girlPinupPink: '💖 Neon Pink',
    levels: {
      1: {
        name: 'Neon Strip Club',
        bannerSub: ''
      },
      2: {
        name: 'Penthouse: Bachelor Party',
        bannerSub: 'SPEED x1.5! HANG ON!'
      },
      3: {
        name: 'Ibiza Paradise Beach',
        bannerSub: 'HARDCORE! DODGE FAST!'
      }
    },
    floating: {
      boom: '💥 BOOM!',
      turbo: '⚡ TURBO +5',
      turboBadge: '⚡ TURBO'
    },
    analyticsLabel: '📊 Anonymous Analytics',
    analyticsDesc: 'Helps improve the game (no personal data)',
    analyticsOn: 'ON',
    analyticsOff: 'OFF'
  }
};

export function getTranslation(lang: Language): I18nDictionary {
  return TRANSLATIONS[lang] || TRANSLATIONS.ru;
}

export function getLevelTranslation(levelId: number, lang: Language): LevelI18n {
  const dict = getTranslation(lang);
  return dict.levels[levelId] || { name: `Level ${levelId}`, bannerSub: '' };
}
